<template>
    <div class="notice_bar red">
        <h2 class="notice_bar__text"><span v-html="promoText"></span></h2>
        <nuxtLink v-if="promoLink" class="notice_bar__link" :to="promoLink">Learn More</nuxtLink>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //promoText: 'Early Access: Please report any issues you encounter <a href="https://cloud.seatable.io/dtable/forms/8356b9f8-134c-48b8-8af1-e114eed9fce6/" target="_blank">here</a>',// 'Discover our Black Friday Deals',
            promoText: '⏰ Last Chance To Save! Check out the deals 👉 <a href="/sale/">here</a>',
            promoLink: '', // '/deals'
        }
    }
}
</script>

<style lang="scss">
@use "~/common/scss/variables";

.notice_bar {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: variables.$noticeBarBackground;
  padding: 0.5rem 0;
  gap: 30px;

  .notice_bar__text {
    font-family: variables.$noticeBarFontFamily;
    font-size: 1.2rem;
  }

  .notice_bar__link {
    background: #000;
    border: none;
    border-radius: 3px;
    padding: 5px 25px;
    color: #fff;
    text-decoration: none;
    &:hover {
      background: #fff;
      color: #000;
    }
  }

  .notice_bar__text,
  .notice_bar__text a {
    color: #fff;
  }
  .notice_bar__link {
    color: #fff;
  }

  &.black {
    background: #000;;
  }

  &.red {
    background: #e2362c;
    background-image: radial-gradient(#9d0000, transparent);
  }
}
</style>